import React from "react";

import {
  setConfirmationButtonDisableStatus,
  setForwardedTeamLeadId,
} from "@src/services/slices/nextStepModalSlice";
import { useGetTeamLeadsQuery } from "@src/services/apis/employeesApi";
import { Employee } from "@src/types";
import { Form, Select } from "antd";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const ForwardSelection: React.FC = () => {
  const loggedInUser: Employee = cookies.get("loggedInuser");
  const { data: teamLeads } = useGetTeamLeadsQuery();

  const dispatch = useDispatch();

  /**
   * Callback function to handle the team lead selection event
   *
   * @param {number} selectedTeamLeadId   The selected team lead id
   */
  function onTeamLeadSelected(selectedTeamLeadId: number): void {
    dispatch(setForwardedTeamLeadId(selectedTeamLeadId));
    dispatch(setConfirmationButtonDisableStatus(!selectedTeamLeadId));
  }

  return (
    <Form layout="vertical">
      <Form.Item label="Forward To" data-testid="forward-select-form">
        <Select
          placeholder="please select a team lead"
          showSearch
          allowClear
          onChange={onTeamLeadSelected}
          data-testid="forward-select"
          optionFilterProp="label"
          options={teamLeads
            ?.filter((lead) => lead.employeeId !== loggedInUser.employeeId)
            ?.map((teamLead: Employee) => ({
              value: teamLead.employeeId,
              label: teamLead.fullName,
            }))}
        />
      </Form.Item>
    </Form>
  );
};

export default ForwardSelection;
